<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleBrandModal('add')">+ 添加品牌</div>
        <!-- <span class="tip">轮播图最多上传10张，支持jpg/png</span> -->
        <el-table
          :data="brandList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="活动名称"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleBrandModal('edit', scope.row)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBrand(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
        <!-- 分页按钮 -->
        <div class="footer">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            background
            layout="total, prev, pager, next, jumper"
            :page-size="size"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addBrandShow"
      class="dialog"
      width="450px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "添加" : "编辑") + "" }}
      </div>
      <el-form ref="form" class="banner-form" label-width="auto">
        <el-form-item label="品牌名称：" prop="link" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入品牌名称"
            class="add-renovation-input"
            v-model="brandName"
            style="width: 254px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addBrandShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleBrand"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '商品品牌设置'
      },
      brandList: [], // 轮播列表
      addBrandShow: false,
      brandName: '',
      type: ''

    };
  },
  mounted() {
    // 获取列表
    this.getBrandList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getBrandList();
    },
    // 获取轮播列表
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {
        page: this.currentPage,
        size: this.size,
      }).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleBrandModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.brandId = rowData.id;
        this.brandName = rowData.name
      } else {
        this.brandName = '';
        // this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addBrandShow = true;
    },
    // 删除轮播图
    deleteBrand(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该品牌吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteBrand, {
            brand: {
                id
            }
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getBrandList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleBrand() {
        let url =
            this.type === 'add'
              ? this.$root.addBrand
              : this.$root.updateBrand;
          let method =
            this.type === 'add'
              ? 'httpPost'
              : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                    name: this.brandName
                }
              : {
                    name: this.brandName,
                  id: this.brandId
                };
          this.loading++;
          this[method](url, {
            brand: inputData
          }).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addBrandShow = false;
              this.getBrandList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .banner-form {
    margin-top: 20px;
    margin-bottom: 20px;
    flex-y(center);
  //   padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
